/*
 * View for loading screens
 */

define(["marionetteBase", "spin", "loading/template/loadingTemplate.html"], function (
  MarionetteBase,
  Spinner,
  LoadingTemplate,
) {
  "use strict";

  // Adjust for the fact that Marionette might have come from node_modules, in which case it includes a "default" value
  // at the top level that is really what we want
  // noinspection JSUnresolvedVariable
  const Marionette = MarionetteBase.default || MarionetteBase.Marionette || MarionetteBase;
  const LoadingView = {};

  LoadingView.loadingView = Marionette.ItemView.extend({
    template: LoadingTemplate,
    className: "max-height",
    onRender: function () {
      //create a spinner from http://fgnass.github.io/spin.js/
      const spinOptions = {
        lines: 12, // The number of lines to draw
        length: 8, // The length of each line
        width: 3, // The line thickness
        radius: 8, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: "#000", // #rgb or #rrggbb or array of colors
        speed: 1, // Rounds per second
        trail: 50, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: "spinner", // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: "50%", // Top position relative to parent
        left: "50%", // Left position relative to parent
      };
      new Spinner(spinOptions).spin(this.$el.find("div")[0]);
    },
  });

  return LoadingView;
});
